// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

input,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

/* .react-pdf__Page__canvas {
  margin: 0 auto;
  width: 80% !important;
  height: 100% !important;
} */

/* .react-pdf__Page__textContent {
  width: 80% !important;
  height: auto !important;
} */

/* .react-pdf__Page {
  overflow: hidden;
} */

/* @media (min-width: 768px) {
  .react-pdf__Page__canvas {
    width: 566px !important;
    height: 793px !important;
  }
} */

.social-media-icon {
  cursor: pointer;
  transition: fill 150ms ease-in-out;
}

.social-media-icon:hover {
  fill: white;
  transition: fill 150ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;;cAEY;AACd;;AAEA;;;;GAIG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;;;;;GAKG;;AAEH;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC","sourcesContent":["html {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\ninput,\ntextarea {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n}\n\n/* .react-pdf__Page__canvas {\n  margin: 0 auto;\n  width: 80% !important;\n  height: 100% !important;\n} */\n\n/* .react-pdf__Page__textContent {\n  width: 80% !important;\n  height: auto !important;\n} */\n\n/* .react-pdf__Page {\n  overflow: hidden;\n} */\n\n/* @media (min-width: 768px) {\n  .react-pdf__Page__canvas {\n    width: 566px !important;\n    height: 793px !important;\n  }\n} */\n\n.social-media-icon {\n  cursor: pointer;\n  transition: fill 150ms ease-in-out;\n}\n\n.social-media-icon:hover {\n  fill: white;\n  transition: fill 150ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
